import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = '页面未找到 - 宅男视频';
  }, []);

  return (
    <div className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="mx-auto max-w-lg text-center">
        <p className="text-7xl md:text-9xl font-black text-background-300 leading-none select-none">404</p>
        <h1 className="mt-6 text-xl md:text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的页面不存在：<span className="font-mono text-foreground-800">{location.pathname}</span>
        </p>
        <p className="mt-2 text-sm text-foreground-500">返回首页或去分类页继续逛逛吧。</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 font-medium text-sm whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-search-line"></i>
            搜索内容
          </Link>
        </div>
      </div>
    </div>
  );
}